import React from 'react';
import './ScenarioModal.css';
import ModalShell from '../ModalShell/ModalShell';
import { useI18n } from '../../i18n/I18nContext';

// Props for the ScenarioModal component.
export interface ScenarioModalProps {
  scenarios: string[];
  title?: string;
  description?: string;
  emptyMessage?: string;
  onSelectScenario: (name: string) => void;
  onClose: () => void;
}

const ScenarioModal: React.FC<ScenarioModalProps> = ({
  scenarios = [],
  title,
  description,
  emptyMessage,
  onSelectScenario,
  onClose,
}) => {
  const { t } = useI18n();
  const resolvedTitle = title ?? t('scenario.loadTitle');
  const resolvedEmptyMessage = emptyMessage ?? t('scenario.empty');
  return (
    <ModalShell onClose={onClose} ariaLabel={resolvedTitle}>
        <h3>{resolvedTitle}</h3>
        {description ? <p className="scenario-modal-description">{description}</p> : null}
        {scenarios.length === 0 && <p>{resolvedEmptyMessage}</p>}
        <ul className="scenario-list">
          {scenarios.map(name => (
            <li key={name}>
              <button
                type="button"
                onClick={() => {
                  onSelectScenario(name);
                  onClose();
                }}
              >
                {name}
              </button>
            </li>
          ))}
        </ul>
    </ModalShell>
  );
};

export default ScenarioModal;
